'use client';
import { memo, useState } from 'react';
import { Flex, VStack } from '@chakra-ui/react';

import SliderControls from 'features/SliderControls';
import { useSwiperControls } from 'shared/hooks';
import NextImage from 'shared/NextImage';
import Slider from 'shared/Slider';

const ProjectScreens = ({ screens }) => {
  const [swiper, setSwiper] = useState(null);
  const controls = useSwiperControls(swiper);

  return (
    <VStack w="full" align="end" gap={{ mobile: '16px', laptop: '24px' }}>
      {Array.isArray(screens) ? (
        <>
          <SliderControls {...controls} />

          <Slider
            controller={swiper}
            setController={setSwiper}
            slidesData={screens}
            SlideComponent={SlideWithScreen}
            mousewheel={false}
            lazyPreloadPrevNext={0}
            isBreakpoints={false}
          />
        </>
      ) : (
        <SlideWithScreen {...screens} />
      )}
    </VStack>
  );
};

export default ProjectScreens;

const SlideWithScreenComponent = ({ ...screenInfo }) => (
  <Flex
    w="full"
    bg="bg.grayLight"
    h={{ mobile: '250px', tablet: '500px', laptop: '645px' }}
    p={{ mobile: '24px 21px', tablet: '48px 52px', laptop: '51px 71px' }}
    borderRadius={{ mobile: '24px', tablet: '32px', laptop: '48px' }}
  >
    <NextImage
      loading="lazy"
      src={screenInfo}
      alt="Скриншот продукта"
      w="full"
      h="auto"
      objectFit="contain"
    />
  </Flex>
);
const SlideWithScreen = memo(SlideWithScreenComponent);
